import { redirect } from 'react-router-dom';

const accessKey = 'access';
const ADMIN = 'admin';
const DEV = 'dev';
const DEVUSER = 'devuser';

const tokenKey = 'token';
const expireKey = 'expiretoken';
const EXPIRED = 'EXPIRED';

const userKey = 'user';

export function setAuthToken(token) {
  localStorage.setItem(tokenKey, token);
  const expiration = new Date();
  expiration.setHours(expiration.getHours() + 1);
  localStorage.setItem(expireKey, expiration.toISOString());
}

export function setAccess(access) {
  localStorage.setItem(accessKey, access);
}

export function setUser(user) {
  localStorage.setItem(userKey, user);
}

export function getAuthToken() {
  const token = localStorage.getItem(tokenKey);

  if (hasAuthTokenExpired()) {
    return EXPIRED;
  }

  return token;
}

export function getAccessLevel() {
  const accessLevel = localStorage.getItem(accessKey);

  if (hasAuthTokenExpired()) {
    return null;
  }

  return accessLevel;
}

export function getUser() {
  const user = localStorage.getItem(userKey);

  if (hasAuthTokenExpired()) {
    return null;
  }

  return user;
}

export function getAuthTokenDuration() {
  const expire = localStorage.getItem(expireKey);
  if (!expire) {
    return -1;
  }
  const expiration = new Date(expire);
  const now = new Date();
  const duration = expiration.getTime() - now.getTime();
  return duration;
}

export function hasAuthTokenExpired() {
  const duration = getAuthTokenDuration();
  return (duration < 0);
}

export function hasAuthToken() {
  const token = getAuthToken();
  return token !== null && token !== EXPIRED;
}

export function isAdmin() {
  if (!hasAuthToken()) {
    return false;
  }
  const accessLevel = getAccessLevel();
  return accessLevel !== null && (accessLevel === ADMIN || accessLevel === DEV);
}

export function isDev() {
  if (!hasAuthToken()) {
    return false;
  }
  const accessLevel = getAccessLevel();
  return accessLevel !== null && (accessLevel === DEV || accessLevel === DEVUSER);
}

export function clearAuthToken(token) {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(expireKey);
  localStorage.removeItem(accessKey);
  localStorage.removeItem(userKey);
}

export function tokenAuthLoader() {
  return getAuthToken();
}

export function checkAuthLoader() {
  if (!hasAuthToken()) {
    return redirect('/auth');
  }
  return null;
}
